const homePageSlider = new Swiper('[js-image-with-text]', {
  loop: false,
  slidesPerView: 1.6,
  paginationClickable: true,
  spaceBetween: 32,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    1920: {
      slidesPerView: 1.6,
      spaceBetween: 32
    },
    1028: {
      slidesPerView: 1.6,
      spaceBetween: 30
    },
    768: {
      slidesPerView: 1,
      spaceBetween: 20
    },
    480: {
      slidesPerView: 1.3,
      spaceBetween: 16
    },
    0: {
      slidesPerView: 1.3,
      spaceBetween: 16
    }
  }
});
function featuredSection() {
  const featuredBlocks = document.querySelectorAll('[js-feature-block]');
  const featuredTexts = document.querySelectorAll('[js-feature-text]');
  featuredBlocks.forEach((block) => {
    block.classList.remove('active');
  });
  featuredTexts.forEach((text) => {
    text.classList.remove('active');
  });
  if (window.innerWidth < 767) {
    if (featuredBlocks.length > 0 && featuredTexts.length > 0) {
      featuredBlocks[0].classList.add('active');
      featuredTexts[0].classList.add('active');
    }
    featuredBlocks.forEach((ele, index) => {
      ele.addEventListener('click', () => {
        featuredBlocks.forEach((block) => {
          block.classList.remove('active');
        });
        featuredTexts.forEach((text) => {
          text.classList.remove('active');
        });
        ele.classList.add('active');
        featuredTexts[index].classList.add('active');
      });
    });
  }
}

featuredSection();
window.addEventListener('resize', featuredSection);
function initCartUpsellSlider() {
  new Swiper(document.querySelector('[hb-js-cart-upsell-slide]'), {
    slidesPerView: 1.2,
    spaceBetween: 8,
    grabCursor: true,
    freeMode: true,
    breakpoints: {
      0: {
        slidesPerView: 1.2,
        spaceBetween: 8,
      },
      768: {
        slidesPerView: 1.2,
      },
    },
  });
};
document.addEventListener("cart-upsell-slider:init", initCartUpsellSlider);

const mainProduct = document.querySelector("[js-main-product]");
if (mainProduct) {
  const MoreInfoBtns = document.querySelectorAll('[js-more-info-btn]');
  const detailsModals = document.querySelectorAll('[js-more-details-modal]');

  MoreInfoBtns.forEach((button, indx) => {
    button.addEventListener('click', function () {
      detailsModals[indx].classList.toggle('open');
    });
  });
}

new Swiper('[js-slideshow-tab]', {
  loop: true,
  slidesPerView: "auto",
  paginationClickable: true,
  spaceBetween: 34,
});